import packageJson from '../../package.json';

const NAME_AND_VERSION_KEY = 'nameAndVersion';
// The version comes from the release tag, injected at build time by deploy.yml.
// package.json deliberately carries no version field: a number sitting there
// would have to be maintained in step with releases to stay true, and when it
// was not, it read as authoritative while being two releases stale - which is
// how v1.0.23 and v1.0.24 both came to report "v. 1.0.22" on a tablet.
//
// Anything not built from a tag says so plainly instead of guessing.
export const CURRENT_VERSION = process.env.REACT_APP_VERSION || 'dev';
export const NAME_AND_VERSION = `${packageJson.name} ${CURRENT_VERSION}`;

function PWAUpdater() {
    const lastKnownVersion = localStorage.getItem(NAME_AND_VERSION_KEY);
    const currentVersion = NAME_AND_VERSION;
    localStorage.setItem(NAME_AND_VERSION_KEY, currentVersion);

    if (currentVersion !== lastKnownVersion) {
        window.location.reload();
    }

    return null;
}

export default PWAUpdater;